// @ts-nocheck
import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = Handler<{
    alternativeSummary: string;
    alternativeType: string;
    currentProductNumber: string;
}>;

export const setProductAlternatePackagingValues: HandlerType = props => {
    props.dispatch({
        type: "Greif/Data/ProductAlternatePackaging/SetAlternatePackaging",
        parameter: props.parameter,
    });
};

export const chain = [setProductAlternatePackagingValues];

const setProductAlternatePackaging = createHandlerChainRunner(chain, "SetAlternatePackaging");
export default setProductAlternatePackaging;
